import { AnunciosData, GetVoidAnunciosData } from "../Anuncio/AnuncioData";

export interface AnuncioInteraccion {
    anuncio: AnunciosData,
    bdInteraccion: number,
}

export function GetVoidAnuncioInteraccion(): AnuncioInteraccion {
    return {
        anuncio: GetVoidAnunciosData(),
        bdInteraccion: 0,
    }
}